import Widget                 from "lib/widget"
import { googleGeocomplete }  from "servos/googlePlaces"


class GeocompletedAddress extends Widget {
  constructor({ root, selector = ".address", options = {} }) {
    super(root)
    this.selector = selector
    this.options  = options

    geocompleteAddress.call(this)
  }
}

const geocompleteAddress = function () {
  const input = this.root.find(`:input${this.selector}`)
  googleGeocomplete.call(this, input, this.selector, this.options)
  input.on("geocomplete:result", (e, result) => {
    fillInForm.call(this, result)
  })
}

const fillInForm = function(result) {
  for (let key in result) { this.root.find(`:input.${key}`).val(result[key]) }
}

export default GeocompletedAddress
